<template>
<div class="quizier-module module-oembed">
    <div class="row">
        <div class="col-md-12" v-if="code_preview">
            <div v-html="code_preview" class="initSocial"></div>
        </div>
    </div>
</div>
</template>
<script>
import mixinComponent from '../mixins';

export default {
    props: [],
    mixins: [mixinComponent],
    data() {
        return {
        }
    },
    computed: {
        code_preview: function () {
            return this.has('preview', '');
        }
    }
}
</script>
